// extracted by mini-css-extract-plugin
export default {"cls1":"n_aPRXnzrmkr1YVST3Fy","cls2":"nihA4snc8wUM3xEf1l0g n_aPRXnzrmkr1YVST3Fy"};